import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=156756b4&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports